<!-- <div class="section">
  <app-service-chart [currentServices]="graph_curr" [previousServices]="graph_prev"
    [viewType]="selectedView"></app-service-chart>
</div> -->

<div class="card-header flex justify-between items-center mt-3 p-16">
  <div class="exp">
    <h4 class="text-lg font-semibold">Amazon Web Services India Private Limited</h4>
  </div>
  <div class="ser mt-4">
    <div>
      <p>Total active services</p>
      <h5><strong>{{totactiveser}}</strong></h5>
    </div>
    <div>
      <p>Total service charges in USD</p>
      <h5 class="text-end"><strong>{{ total | number: '1.2-2' }} USD</strong></h5>
    </div>
  </div>
</div>

<div class="flex-wrap align-items-center justify-content-between p-3 border">
  <!-- <div class="d-flex flex-wrap align-items-center gap-4">
    <app-filter-by-tags *ngIf="selectedView == 'monthly'" [showModal]="filteredTag" [monthYear]="monthYear"
      [accountId]="accountId" (tagsFiltered)="onTagsFiltered($event)">
    </app-filter-by-tags>

    <app-preferences [pref]="preferencesData" [monthYear]="monthYear" [filteredTag]="filteredTag"
      [selectedView]="selectedView" [accountId]="accountId" (pageSizeChange)="handlePageSizeChange($event)"
      (responseToParent)="handlePreferencesResponse($event)">
    </app-preferences>
  </div> -->

  <div class="d-flex flex-wrap align-items-center gap-4 justify-content-between">
    <div class="input-group mb-4 w-50 mt-4">
      <span class="input-group-text bg-white border-end-0">
        <i class="fa-solid fa-magnifying-glass text-muted"></i>
      </span>
      <input type="text" [(ngModel)]="searchTerm" class="form-control border-start-0"
        placeholder="Filter by service or region name" (ngModelChange)="onSearch()" />
    </div>

        <div class="d-flex flex-wrap align-items-center gap-4">
       <div class="dropdown">
    <button class="btn btn-outline-primary dropdown-toggle shadow-sm" data-bs-toggle="dropdown">
      Breakpoints: <i class="fa-solid fa-layer-group"></i>
    </button>
    <div class="dropdown-menu p-3 shadow-lg rounded-3" style="min-width: 220px;">
      <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="regionCheck" [(ngModel)]="breakpoints.region">
          <label class="form-check-label" for="regionCheck">Region</label>
      </div>
      <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="tagNameCheck1" [(ngModel)]="breakpoints.product_family">
          <label class="form-check-label" for="tagNameCheck1">Product Family</label>
      </div>
      <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" id="tagNameCheck2" [(ngModel)]="breakpoints.line_item">
          <label class="form-check-label" for="tagNameCheck2">Line Item</label>
      </div>
      <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="clearPreferences()">Clear</button>
      <button type="button" class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
      </div>
    </div>
  </div>
      <button class="btn btn-outline-primary" (click)="toggleExpandAll()">
        <i class="fa" [ngClass]="isExpandedAll ? 'fa-square-minus' : 'fa-square-plus'"></i>
        {{ isExpandedAll ? 'Minimize All' : 'Expand All' }}
      </button>
    </div>
  </div>

  <div class="table-responsive" >
    <table class="table table-hover table-striped" style="border-collapse: collapse;">
      <thead>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <th *ngFor="let header of headers">{{ header.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!filteredList?.length">
          <td colspan="4" class="text-center text-muted py-3">No data found</td>
        </tr>

        <ng-container *ngFor="let service of paginatedList; trackBy: trackByProductCode">

          <!-- Level 1: Product Name -->
          <tr style="border-bottom: 1px solid #dee2e6; background-color: #f8f9fa;">
            <td>
              <span (click)="toggleProductName(service)" class="d-inline-flex align-items-center" role="button"
                style="cursor: pointer;">
                <i class="fa me-1" [ngClass]="isProductNameExpanded(service) ? 'fa-minus' : 'fa-plus'"></i>
                {{ service.product_name || service.product_code }}
              </span>
            </td>
            <td></td>
            <td><strong>USD {{ service.base_cost | number:'1.2-2' }}</strong></td>
            <td><strong>USD {{ service.final_cost | number:'1.2-2' }}</strong></td>
          </tr>

          <!-- Level 2: Product Code -->
          <tr *ngIf="isProductNameExpanded(service)" style="border-bottom: 1px solid #dee2e6;">
            <td style="padding-left: 40px;">
              <span *ngIf="service.regions?.length" (click)="toggle(service)" class="d-inline-flex align-items-center"
                role="button" style="cursor: pointer;">
                <i class="fa me-1" [ngClass]="service.expanded ? 'fa-minus' : 'fa-plus'"></i>
                {{ service.product_code }}
              </span>
              <span *ngIf="!service.regions?.length">{{ service.product_code }}</span>
            </td>
            <td></td>
            <td><strong>USD {{ service.base_cost | number:'1.2-2' }}</strong></td>
            <td><strong>USD {{ service.final_cost | number:'1.2-2' }}</strong></td>
          </tr>

          <!-- Level 3: Regions -->
          <ng-container *ngIf="service.expanded">
            <ng-container *ngFor="let region of service.regions">
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding-left: 80px;">
                  <span *ngIf="region.product_families?.length" (click)="toggle(region)"
                    class="d-inline-flex align-items-center" role="button" style="cursor: pointer;">
                    <i class="fa me-1" [ngClass]="region.expanded ? 'fa-minus' : 'fa-plus'"></i>
                    {{ region.region }}
                  </span>
                  <span *ngIf="!region.product_families?.length">{{ region.region }}</span>
                </td>
                <td></td>
                <td>USD {{ region.base_cost | number:'1.2-2' }}</td>
                <td>USD {{ region.final_cost | number:'1.2-2' }}</td>
              </tr>

              <!-- Level 4: Product Families -->
              <ng-container *ngIf="region.expanded">
                <ng-container *ngFor="let pf of region.product_families">
                  <tr style="border-bottom: 1px solid #dee2e6;">
                    <td style="padding-left: 120px;">
                      <span *ngIf="pf.operations?.length" (click)="toggle(pf)" class="d-inline-flex align-items-center"
                        role="button" style="cursor: pointer;">
                        <i class="fa me-1" [ngClass]="pf.expanded ? 'fa-minus' : 'fa-plus'"></i>
                        {{ pf.product_family }}
                      </span>
                      <span *ngIf="!pf.operations?.length">{{ pf.product_family }}</span>
                    </td>
                    <td></td>
                    <td>USD {{ pf.base_cost | number:'1.2-2' }}</td>
                    <td>USD {{ pf.final_cost | number:'1.2-2' }}</td>
                  </tr>

                  <!-- Level 5: Operations -->
                  <ng-container *ngIf="pf.expanded">
                    <ng-container *ngFor="let op of pf.operations">
                      <tr style="border-bottom: 1px solid #dee2e6;">
                        <td style="padding-left: 160px;">
                          <span *ngIf="op.line_items?.length" (click)="toggle(op)"
                            class="d-inline-flex align-items-center" role="button" style="cursor: pointer;">
                            <i class="fa me-1" [ngClass]="op.expanded ? 'fa-minus' : 'fa-plus'"></i>
                            {{ op.operation }}
                          </span>
                          <span *ngIf="!op.line_items?.length">{{ op.operation }}</span>
                        </td>
                        <td></td>
                        <td>USD {{ op.base_cost | number:'1.2-2' }}</td>
                        <td>USD {{ op.final_cost | number:'1.2-2' }}</td>
                      </tr>

                      <!-- Level 6: Line Items -->
                      <ng-container *ngIf="op.expanded">
                        <ng-container *ngFor="let li of op.line_items">
                          <tr style="border-bottom: 1px solid #dee2e6;">
                            <td style="padding-left: 200px;">
                              {{ li.line_item }}
                            </td>
                            <td>{{ li.total_usage_amount | number:'1.2-2' }} {{ li.unit }}</td>
                            <td>USD {{ li.base_cost | number:'1.2-2' }}</td>
                            <td>USD {{ li.final_cost | number:'1.2-2' }}</td>
                          </tr>
                        </ng-container>
                      </ng-container>

                    </ng-container>
                  </ng-container>

                </ng-container>
              </ng-container>

            </ng-container>
          </ng-container>

        </ng-container>
      </tbody>
    </table>

    <div class="d-flex justify-center align-items-center mt-3" *ngIf="totalPages > 1">
      <i class="fa fa-angle-left fa-lg cursor-pointer mx-2" [class.text-muted]="currentPage === 1"
        (click)="goToPreviousPage()"></i>
      <span class="mx-2">Page {{ currentPage }} of {{ totalPages }}</span>
      <i class="fa fa-angle-right fa-lg cursor-pointer mx-2" [class.text-muted]="currentPage >= totalPages"
        (click)="goToNextPage()"></i>
    </div>
  </div>
</div>

<!-- Marketplace Section -->
<div class="card-header flex justify-between items-center mt-3 p-16">
  <div class="exp">
    <h4 class="text-lg font-semibold">Amazon Web Services, Inc. - MarketPlace</h4>
  </div>
  <div class="ser mt-4">
    <div>
      <p>Total active services</p>
      <h5><strong>{{ market_totactiveser }}</strong></h5>
    </div>
    <div>
      <p>Total service charges in USD</p>
      <h5 class="text-end"><strong>{{ market_total | number: '1.2-2' }} USD</strong></h5>
    </div>
  </div>
</div>

<div class="flex-wrap align-items-center justify-content-between p-3 border mt-3">
  <div class="d-flex align-items-center justify-content-between">
    <div class="input-group mb-4 w-50 mt-4">
      <span class="input-group-text bg-white border-end-0">
        <i class="fa-solid fa-magnifying-glass text-muted"></i>
      </span>
      <input type="text" [(ngModel)]="market_searchTerm" (ngModelChange)="market_onSearch()"
        class="form-control border-start-0" placeholder="Filter by service or region name" />
    </div>
    <div>
      <button class="btn btn-outline-primary" (click)="market_toggleExpandAll()">
        <i class="fa" [ngClass]="market_isExpandedAll ? 'fa-square-minus' : 'fa-square-plus'"></i>
        {{ market_isExpandedAll ? 'Minimize All' : 'Expand All' }}
      </button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-hover table-striped" style="border-collapse: collapse;">
      <thead>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <th *ngFor="let market_header of headers">{{ market_header.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!market_filteredList?.length">
          <td colspan="4" class="text-center text-muted py-3">No data found</td>
        </tr>

        <ng-container *ngFor="let market_service of marketPaginatedList; trackBy: trackByProductCode">

          <!-- Level 1: Product Name -->
          <tr style="border-bottom: 1px solid #dee2e6; background-color: #f8f9fa;">
            <td>
              <span (click)="toggleProductName(market_service)" class="d-inline-flex align-items-center" role="button"
                style="cursor: pointer;">
                <i class="fa me-1" [ngClass]="isProductNameExpanded(market_service) ? 'fa-minus' : 'fa-plus'"></i>
                {{ market_service.product_name || market_service.product_code }}
              </span>
            </td>
            <td></td>
            <td><strong>USD {{ market_service.base_cost | number:'1.2-2' }}</strong></td>
            <td><strong>USD {{ market_service.final_cost | number:'1.2-2' }}</strong></td>
          </tr>

          <!-- Level 2: Product Code -->
          <tr *ngIf="isProductNameExpanded(market_service)" style="border-bottom: 1px solid #dee2e6;">
            <td style="padding-left: 40px;">
              <span *ngIf="market_service.regions?.length" (click)="toggle(market_service)"
                class="d-inline-flex align-items-center" role="button" style="cursor: pointer;">
                <i class="fa me-1" [ngClass]="market_service.expanded ? 'fa-minus' : 'fa-plus'"></i>
                {{ market_service.product_code }}
              </span>
              <span *ngIf="!market_service.regions?.length">{{ market_service.product_code }}</span>
            </td>
            <td></td>
            <td><strong>USD {{ market_service.base_cost | number:'1.2-2' }}</strong></td>
            <td><strong>USD {{ market_service.final_cost | number:'1.2-2' }}</strong></td>
          </tr>

          <!-- Level 3: Regions -->
          <ng-container *ngIf="market_service.expanded">
            <ng-container *ngFor="let market_region of market_service.regions">
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding-left: 80px;">
                  <span *ngIf="market_region.product_families?.length" (click)="toggle(market_region)"
                    class="d-inline-flex align-items-center" role="button" style="cursor:pointer;">
                    <i class="fa me-1" [ngClass]="market_region.expanded ? 'fa-minus' : 'fa-plus'"></i>
                    {{ market_region.region }}
                  </span>
                  <span *ngIf="!market_region.product_families?.length">{{ market_region.region }}</span>
                </td>
                <td></td>
                <td>USD {{ market_region.base_cost | number:'1.2-2' }}</td>
                <td>USD {{ market_region.final_cost | number:'1.2-2' }}</td>
              </tr>

              <!-- Level 4: Product Families -->
              <ng-container *ngIf="market_region.expanded">
                <ng-container *ngFor="let market_pf of market_region.product_families">
                  <tr style="border-bottom: 1px solid #dee2e6;">
                    <td style="padding-left: 120px;">
                      <span *ngIf="market_pf.operations?.length" (click)="toggle(market_pf)"
                        class="d-inline-flex align-items-center" role="button" style="cursor: pointer;">
                        <i class="fa me-1" [ngClass]="market_pf.expanded ? 'fa-minus' : 'fa-plus'"></i>
                        {{ market_pf.product_family }}
                      </span>
                      <span *ngIf="!market_pf.operations?.length">{{ market_pf.product_family }}</span>
                    </td>
                    <td></td>
                    <td>USD {{ market_pf.base_cost | number:'1.2-2' }}</td>
                    <td>USD {{ market_pf.final_cost | number:'1.2-2' }}</td>
                  </tr>

                  <!-- Level 5: Operations -->
                  <ng-container *ngIf="market_pf.expanded">
                    <ng-container *ngFor="let market_op of market_pf.operations">
                      <tr style="border-bottom: 1px solid #dee2e6;">
                        <td style="padding-left: 160px;">
                          <span *ngIf="market_op.line_items?.length" (click)="toggle(market_op)"
                            class="d-inline-flex align-items-center" role="button" style="cursor: pointer;">
                            <i class="fa me-1" [ngClass]="market_op.expanded ? 'fa-minus' : 'fa-plus'"></i>
                            {{ market_op.operation }}
                          </span>
                          <span *ngIf="!market_op.line_items?.length">{{ market_op.operation }}</span>
                        </td>
                        <td></td>
                        <td>USD {{ market_op.base_cost | number:'1.2-2' }}</td>
                        <td>USD {{ market_op.final_cost | number:'1.2-2' }}</td>
                      </tr>

                      <!-- Level 6: Line Items -->
                      <ng-container *ngIf="market_op.expanded">
                        <ng-container *ngFor="let market_li of market_op.line_items">
                          <tr style="border-bottom: 1px solid #dee2e6;">
                            <td style="padding-left: 200px;">
                              {{ market_li.line_item }}
                            </td>
                            <td>{{ market_li.total_usage_amount | number:'1.2-2' }} {{ market_li.unit }}</td>
                            <td>USD {{ market_li.base_cost | number:'1.2-2' }}</td>
                            <td>USD {{ market_li.final_cost | number:'1.2-2' }}</td>
                          </tr>
                        </ng-container>
                      </ng-container>

                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>

        </ng-container>
      </tbody>
    </table>

    <div class="d-flex justify-center align-items-center mt-3" *ngIf="marketTotalPages > 1">
      <i class="fa fa-angle-left fa-lg cursor-pointer mx-2" [class.text-muted]="market_currentPage === 1"
        (click)="marketPrev()"></i>
      <span class="mx-2">Page {{ market_currentPage }} of {{ marketTotalPages }}</span>
      <i class="fa fa-angle-right fa-lg cursor-pointer mx-2" [class.text-muted]="market_currentPage >= marketTotalPages"
        (click)="marketNext()"></i>
    </div>
  </div>
</div>